"use client";

import { useEffect } from "react";
import Link from "next/link";
import posthog from "posthog-js";
import { Icon } from "@to/ui";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    <div
      className="flex min-h-screen items-center justify-center p-4"
      style={{
        backgroundColor: "var(--brand-surface-subtle)",
        fontFamily: "var(--brand-font-body)",
      }}
    >
      <div
        className="w-full max-w-md rounded-2xl p-8 text-center shadow-sm"
        style={{
          backgroundColor: "var(--brand-surface)",
          border: "1px solid var(--brand-card-border)",
        }}
      >
        <Icon
          name="error_outline"
          size={48}
          className="mx-auto mb-4"
          style={{ color: "var(--brand-primary)" }}
        />
        <h1
          className="mb-3 text-2xl font-bold"
          style={{
            fontFamily: "var(--brand-font-heading)",
            color: "var(--brand-text)",
          }}
        >
          Something went wrong
        </h1>
        <p
          className="mb-6 text-base"
          style={{ color: "var(--brand-text-muted)" }}
        >
          The TrustedOnly team has been notified and is working on resolving it.
          Please try again in a moment.
        </p>
        <div className="flex flex-col items-center gap-3">
          <button
            onClick={reset}
            className="inline-flex h-10 items-center gap-2 rounded-full px-5 text-sm font-semibold"
            style={{
              backgroundColor: "var(--brand-primary)",
              color: "var(--brand-on-primary, #fff)",
            }}
          >
            <Icon name="refresh" size={16} />
            Try again
          </button>
          <Link
            href="/"
            className="inline-flex h-10 items-center rounded-full px-5 text-sm font-medium"
            style={{
              color: "var(--brand-primary)",
              border: "1px solid var(--brand-card-border)",
            }}
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
